var React = require('react');

function IconB3Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"#A1BF36","cx":"16","cy":"16.001","r":"16","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M17.23,11.352c0-0.648,0.428-0.798,0.733-0.798c0.3,0,1.853,0,1.853,0V7.709l-2.554-0.01\n\t\tc-2.836,0-3.479,2.123-3.479,3.48v1.896h-1.639v2.931h1.639c0,3.761,0,8.294,0,8.294h3.448c0,0,0-4.576,0-8.294h2.327l0.301-2.931\n\t\tH17.23V11.352z","key":1})]));
}

IconB3Facebook.displayName = "IconB3Facebook";

IconB3Facebook.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3Facebook;

IconB3Facebook.default = IconB3Facebook;
